import { defineMessages } from "react-intl";

export const reviewPageText = defineMessages({
  back: {
    defaultMessage: "Back",
    id: "cyR7Kh",
  },
  defaultDescription: {
    defaultMessage: "Update any relevant information as needed.",
    id: "1PRUQN",
  },
  defaultTitle: {
    defaultMessage: "Please review your submissions",
    id: "thr+qk",
  },
  edit: {
    defaultMessage: "Edit",
    id: "wEQDC6",
  },
  unanswered: {
    defaultMessage: "Unanswered",
    id: "6go3bd",
  },
});
